import PropTypes from 'prop-types';

const FormatType = {
    id: PropTypes.number,
    created_at: PropTypes.string,
    name: PropTypes.string,
    updated_at: PropTypes.string
};
export { FormatType };
